import { render } from "./GroupSettingsDialog.vue?vue&type=template&id=030f1c92&scoped=true&lang=pug"
import script from "./GroupSettingsDialog.vue?vue&type=script&lang=js"
export * from "./GroupSettingsDialog.vue?vue&type=script&lang=js"

import "./GroupSettingsDialog.vue?vue&type=style&index=0&id=030f1c92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030f1c92"]])

export default __exports__